<template>
  <div class="timer">
    <span v-if="!done && traceStatus !== '13'">剩余： {{ day }}天 {{ hour }}小时 {{ min }}分钟 {{ sec }}秒{{ sufText }}</span>
    <span v-else>{{ state4Text[traceStatus] }}</span>
</div>
</template>
<script>
export default {
  props: {
    endTime: {
      type: String,
      default: ''
    },
    sufText: {
      type: String,
      default: '结束竞标'
    },
    traceStatus: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      day: '',
      hour: '',
      min: '',
      sec: '',
      timer: null,
      done: false,
      text: '',
      state4Text: {
        '11': '投标已结束，需求匹配中',
        '12': '投标已结束，需求匹配中',
        '14': '投标已结束，需求匹配中',
        '13': '商户已取消'
      }
    }
  },
  watch: {
    endTime(value) {
      if(value !== '') {
        if(this.timer) {
          clearInterval(this.timer);
        }
        this.initTimer();
        this.timer = setInterval(() => {
          this.initTimer()
        }, 1000);
      }
    },
    
  },
  mounted() {
    
  },
  beforeDestroy() {
    if(this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    initTimer() {
      const endTime = `${this.endTime} 23:59:59`
      const now = new Date().getTime();
      const end = new Date(endTime.replace('-','/')).getTime();
      const leftTime = end - now;
      console.log(leftTime);
      if(leftTime > 0) {
        this.day = Math.floor(leftTime / 1000 / 60 / 60 / 24)
        this.hour = Math.floor((leftTime / 1000 / 60 / 60) % 24)
        this.min = Math.floor((leftTime / 1000 / 60) % 60)
        this.sec = Math.floor((leftTime / 1000) % 60)
      } else {
        this.done = true;
        if(this.timer) {
          clearInterval(this.timer);
        }
      }
    }
  }
}
</script>
<style scoped>
.timer {
  font-size: 12px;
  color: #F74444;
}
</style>